import React, { Component } from 'react';
import styled from 'styled-components';

const Container = styled.div`
border-radius: 5px;`;


interface Switch {
  active: boolean;
  left: boolean;
}

const Switch = styled.button<Switch>`
  min-width: 260.9px;
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  letter-spacing: 0.5px;
  text-transform: uppercase;

  border: none;
  padding: 15px 57px;
  background-color: ${props => props.active ? '#2196F3' : ' #FFFFFF'};
  color: ${props => props.active ? '#FFFFFF' : '#4A4A4A'};
  border-radius: ${props => props.left ? '5px 0px 0px 5px' :  '0px 5px 5px 0px'}
`;





interface MenuProps {
  cheap: boolean;
  fast: boolean;
  change: any;
}

export default class Menu extends Component<MenuProps, {}> {
  render() {
    return (
      <Container onClick={this.props.change}>
        <Switch left={true} data-setting={'setting'} data-checked={true} id='cheap' data-active={'cheap'} data-in-active={'fast'} active={this.props.cheap}> Самый дешевый </Switch>
        <Switch left={false} data-setting={'setting'} data-checked={false} id='fast' data-active={'fast'} data-in-active={'cheap'} active={this.props.fast}> Самый быстрый </Switch>
      </Container>
    )
  }
};